// Membership application form (Google Forms). Used by the "Join us" and "Apply" buttons.
export const APPLY_URL =
  'https://docs.google.com/forms/d/e/1FAIpQLSe86wrK3vNWN0YJABpyJDQfJnWYqw0x7HxtQhxq9Lis-hm6FQ/viewform';
